import { route } from '@/ziggy-shim';
import { api, CastValue } from './LaravelClient';

export default {
  async create(projectId: Id, data: ApiRequests['api.v1.plants.store']) {
    return await api(route('api.v1.plants.store', projectId), 'post', {
      data,
      casts: {
        off_hired_at: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        supplier_name: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        supplier_id: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async update(id: Id, data: ApiRequests['api.v1.plants.update']) {
    return await api(route('api.v1.plants.update', id), 'patch', {
      data,
      casts: {
        off_hired_at: (value, clone, key) =>
          new CastValue(value)
            .cast('nullable', clone, key)
            .get(),
      },
    });
  },

  async delete(id: Id) {
    return await api(route('api.v1.plants.destroy', id), 'delete');
  },

  async show(id: Id) {
    return await api(route('api.v1.plants.show', id), 'get');
  },

  async index(projectId: Id, data: ApiRequests['api.v1.plants.index']) {
    return await api(route('api.v1.plants.index', projectId), 'get', {
      data,
      casts: {
        day_max: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        day_min: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        supplier_name: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        fleet: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        vendor_ref: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async hire(id: Id, data: ApiRequests['api.v1.plants.hire']) {
    return await api(route('api.v1.plants.hire', id), 'patch', {
      data,
      casts: {
        off_hired_at: (value, clone, key) =>
          new CastValue(value)
            .cast('nullable', clone, key)
            .get(),
      },
    });
  },

  async daily(projectId: Id, data: ApiRequests['api.v1.plants.daily']) {
    return await api(route('api.v1.plants.daily', projectId), 'get', {
      data,
      casts: {
        day: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async fetchForSubcontractorClaim(projectId: Id, claimId: Id) {
    return await api(route('api.v1.subcontractor.claims.dayworks.plant.index', [projectId, claimId]), 'get');
  },
};
